<template>
  <div class="wrap" id="wrap">
    <Scrollama @step-enter="stepEnterHandler">
      <div class="step1" data-step="a">
        <div class="div-bg step1">
          <img :src="textData.img">
          <div class="big-data_p animation" v-show="show1">
            <div class="title">{{textData.title}}</div>
            <p class="fnt_24">{{textData.describe}}</p>
            <!--        <el-button>-->
            <!--          查看更多-->
            <!--        </el-button>-->
          </div>
        </div>
      </div>
      <div class="tab-wrap">
        <el-radio-group text-color="#0974fd" @input="radioChange" v-model="menuButton">
          <el-radio-button label="first">{{textData.tab1}} <div class="line"></div></el-radio-button>
          <el-radio-button label="second">{{textData.tab2}}<div class="line"></div></el-radio-button>
          <el-radio-button label="third">{{textData.tab3}}<div class="line"></div></el-radio-button>
          <el-radio-button label="fourth">{{textData.tab4}}</el-radio-button>
        </el-radio-group>
      </div>
      <div class="step2" data-step="b">
        <div class="first-wrap" id="first">
          <div v-show="show2">
            <div class="move-title animationToBottom" style="margin-top: 0">
              {{textData.tab1}}
            </div>
            <div class="move-content animation" :style="{ backgroundImage: `url(${firstData.img})`}">
              <div class="left">
                <div class="left-title">{{firstData.title}}</div>
                <div class="left-text">{{firstData.content}}</div>
              </div>
              <div class="right">
                <div class="container">
                  <div class="right-top">
                    <div class="top-title">{{firstData.titleChild1}}</div>
                    <div class="top-text">{{firstData.contentChild1}}</div>
                  </div>
                  <div class="line"></div>
                  <div class="right-bottom">
                    <div class="bottom-title">{{firstData.titleChild2}}</div>
                    <div class="bottom-text">{{firstData.contentChild2}}</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div >
      </div>
      <div class="step3" data-step="c">
        <div class="second-wrap" id="second">
          <div  v-show="show3">
            <div class="move-title animationToBottom">
              {{textData.tab2}}
            </div>
            <div class="move-content animation">
              <div class="left">
                <div class="left-item">
                  <div>
                    {{secondData.description1}}
                  </div>
                </div>
                <div class="left-item">
                  <div>
                    {{secondData.description2}}
                  </div>
                </div>
                <div class="left-item">
                  <div>
                    {{secondData.description3}}
                  </div>
                </div>
              </div>
              <div class="right" :style="{ background: `url(${secondData.img})`}">
                <div class="lz">
                  <div>{{secondData.title}}</div>
                  <div>{{secondData.content}}</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="step4" data-step="d">
        <div class="three-wrap" id="third">
          <div v-show="show4">
            <div class="move-title animationToBottom" style="margin-top: 0">
              {{textData.tab3}}
            </div>
            <div class="move-content animation">
              <el-tabs v-model="activeName" @tab-click="handleClick">
                <el-tab-pane  :name="'tab' + index" v-for="(item, index) in threeData" :key="index">
                  <div slot="label" class="tab-slot">
                    <div class="fnt-title" @click="titleChange(item.tab)">{{item.tab}}</div>
                  </div>
                  <div class="tab-info">
                    <div class="item">
                      <div class="item-left">
                        {{ item.tab }}
                      </div>
                      <div class="item-right">
                        <div class="right-item" v-for="(it, i) in 4" :key="i">
                          <div class="title" v-if="item['title' + it]">
                            {{item['title' + it]}}
                          </div>
                          <div class="text" v-if="item['content' + it]">
                            {{item['content' + it]}}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </el-tab-pane>
              </el-tabs>
            </div>
          </div>
        </div>
      </div>
      <div class="step5" data-step="e">
        <div class="fourth-wrap" id="fourth">
          <div v-show="show5">
            <div class="move-title animationToBottom" style="margin-top: 0">
              {{textData.tab4}}
            </div>
            <div class="move-content animation">
              <div v-for="(item, index) in fourthData" :key="index"
                   :class="item.checked ? 'main' : 'item'"
                   :style="item.checked ? { background: `url(${item.img}) no-repeat`}
                   : { background: `url(${item.defaultImg}) no-repeat`} "
                   @mouseenter="mouseenterCSS(index)">
                  <div v-show="item.checked" class="title">{{item.title}}</div>
                  <div v-show="item.checked" class="text">{{item.description}}</div>
                  <ul v-show="item.checked">
                    <li>
                      <img src="../../../../static/images/operationFlow/duigou.png">
                      <span>{{item.descriptionChild1}}</span>
                    </li>
                    <li>
                      <img src="../../../../static/images/operationFlow/duigou.png">
                      <span>{{item.descriptionChild2}}</span>
                    </li>
                    <li>
                      <img src="../../../../static/images/operationFlow/duigou.png">
                      <span>{{item.descriptionChild3}}</span>
                    </li>
                  </ul>
                  <div v-show="!item.checked" class="top">
                    <div class="title">{{item.title}}</div>
                    <div class="text">{{item.des}}</div>
                  </div>
                  <div v-show="!item.checked" class="bottom">
                    <div class="attribute">{{item.operation}}</div>
                    <div class="val">
                      {{item.operationName}}
                    </div>
                  </div>
                </div>
<!--              <div class="item" @mouseenter="mouseenterCSS(2)">-->
<!--                <div class="top">-->
<!--                  <div class="title">一汽大众项目</div>-->
<!--                  <div class="text">数据编排开发工厂提供了超20种算子，包括数据清洗、据去、数据转执、数据耿接条件判断、分类标注等</div>-->
<!--                </div>-->
<!--                <div class="bottom">-->
<!--                  <div class="attribute">业务属性</div>-->
<!--                  <div class="val">-->
<!--                    机器人驾驶方案-->
<!--                  </div>-->
<!--                </div>-->
<!--              </div>-->
            </div>
          </div>
        </div>
      </div>
      <div class="step6" data-step="f">
        <footer-item></footer-item>
      </div>
    </Scrollama>
  </div>
</template>
<script>
import Scrollama from 'vue-scrollama'
import footerItem from '../../components/footer-item'
export default {
  components: {
    Scrollama,
    footerItem
  },
  data () {
    return {
      textData: {},
      firstData: {},
      secondData: {},
      threeData: [],
      fourthData: [],
      menuButton: '',
      offsetY: 0,
      activeName: 'tab0',
      show1: false,
      show2: false,
      show3: false,
      show4: false,
      show5: false,
      // 适用场景被点击的标题
      clickTitle: ''
    }
  },
  methods: {
    mouseenterCSS (val) {
      console.log('-------------------------------', val)
      this.fourthData = this.fourthData.map((item, index) => {
        if (index === val) {
          item.checked = true
        } else {
          item.checked = false
        }
        return item
      })
    },
    // 适用场景标题点击
    titleChange (val) {
      console.log(val)
      this.clickTitle = val
    },
    handleClick () {},
    stepEnterHandler ({element, index, direction}) {
      switch (element.className) {
        case 'step1':
          this.show1 = true
          break
        case 'step2':
          this.show2 = true
          break
        case 'step3':
          this.show3 = true
          break
        case 'step4':
          this.show4 = true
          break
        case 'step5':
          this.show5 = true
          break
      }
    },
    radioChange (label) {
      let selector = '#' + label
      document.querySelector(selector).scrollIntoView({
        behavior: 'smooth'
      })
    },
    detailTo (item) {
    }
  },
  created: function () {
    console.log('this.$boss', this.$boss)
    if (this.$boss) {
      this.textData = this.$boss.page201.g201.filter(item => item.link === '业务流程协同')[0]
      this.firstData = this.$boss.page620.g620[0]
      this.secondData = this.$boss.page621.g621[0]
      this.threeData = [...this.$boss.page622.g622]
      this.fourthData = [...this.$boss.page623.g623].reverse().map((item, index) => {
        item.checked = index === 0
        return item
      })
      this.clickTitle = this.threeData[0].title
    }
  }
}
</script>
<style scoped lang="less">
  @media screen and (max-width: 1500px){
    .move-title {
      margin-top: 30px;
      position: relative;
      top: 50px;
      width: 100%;
      z-index: 999;
      font-size: 32px;
      color: #323232;
      font-weight: 500;
    }
    .move-content {
      margin-top: 150px;
      position: relative;
      width: 100%;
      height: 50vh;
      z-index: 999;
      display: flex;
      justify-content: space-between;
    }
    .wrap{
      width: 100%;
      height: 100%;
      /*overflow: auto;*/
    }
    .div-bg {
      width: 100%;
      height:70vh;
      /*background: url("../../../../static/images/productAndService/bigData/bg.png") no-repeat;*/
      img {
        width: 100%;
        height: 100%;
      }
      .big-data_p {
        position: relative;
        left: 100px;
        top: -60%;
        color: #fff;
        text-align: left;
        width: calc(100% - 100px);
        z-index: 999;
      }
      .big-data_p .title, .big-data_p p {
        display: -webkit-box;
        overflow: hidden;
        -webkit-line-clamp: 2;
        -webkit-box-orient: vertical;
      }
      .big-data_p p {
        font-size: 24px;
      }
      .big-data_p .title {
        width: 100%;
        font-size: 42px;
        font-weight: 400;
        margin-bottom: 15px;
        line-height: 60px;
        max-height: 120px;
      }
      .big-data_p .el-button {
        margin-top: 10vh;
        width: 150px;
        color: #FFFFFF;
        background-color: transparent;
        border: 1px solid #FFFFFF;
        font-size: 16px;
      }
    }
    .tab-wrap {
      position: relative;
      top: -35px;
      width: 90%;
      height: 70px;
      margin-left: 5%;
      background-color: #FFFFFF;
      box-shadow: 0 0 8px 8px rgba(0, 18, 31, 0.07);
      .el-radio-group{
        width: 100%;
        height: 70px;
        .el-radio-button{
          width: 25%;
          height: 70px;
          /deep/ .el-radio-button__inner {
            width: 100%;
            height: 70px;
            line-height: 50px;
            font-size: 20px;
            box-shadow: -1px 0 0 0 transparent;
            background-color: transparent;
            color: #323232;
            border: 1px solid transparent;
          }
        }
      }
      /deep/ .line {
        width: 2px;
        height: 50px;
        border-left: 2px solid #f1f1f1;
        float: right;
      }
    }
    .first-wrap{
      width: 100%;
      // margin-left: 5%;
      background: #FFFFFF;
      // height: 60vh;
      .move-content{
        // background-color: cyan;
        width:100%;
        height: 585px;
        padding: 100px;
        box-sizing: border-box;
        display: flex;
        /*background: url("../../../../static/images/operationFlow/cpgn.png") no-repeat;*/
        .left{
          width: 440px;
          display: flex;
          flex-direction: column;
          justify-content: center;
          align-items: center;
          padding:0 100px;
          box-sizing: border-box;
          .left-title{
            font-size: 30px;
            color: #fff;
            font-weight: bold;
            margin-bottom: 20px;
          }
          .left-text{
            font-size: 16px;
            color: #DCE5FE;
            text-align: left;
          }
        }
        .right{
          flex: 1;
          padding:0 100px 0 0;
          box-sizing: border-box;
          .container{
            display: flex;
            flex-direction: column;
            justify-content: space-between;
            border-radius: 10px;
            background-color: rgba(255, 255, 255, 0.8);
            width: 100%;
            height: 100%;
            text-align: left;
            padding: 50px;
            box-sizing: border-box;
            .right-top{
              .top-title{
                font-size: 30px;
                font-weight: bold;
              }
              .top-text{
                margin-top: 20px;
                font-size: 16px;
                // color: #DCE5FE;
              }
            }
            .right-bottom{
              .bottom-title{
                font-size: 30px;
                font-weight: bold;
              }
              .bottom-text{
                margin-top: 20px;
                font-size: 16px;
                // color: #DCE5FE;
              }
            }
            .line{
              height: 1px;
              width: 100%;
              background-color: #F0F1F1;
            }
          }

        }
      }
    }
    .second-wrap {
      width: 100%;
      height: 40em;
      // height: 950px;
      // background: url("../../../../static/images/productAndService/bigData/core-bg.png") no-repeat;
      // background-size: 100% 100%;
      padding-bottom: 50px;
      .move-content {
        display: flex;
        padding:0 100px;
        box-sizing: border-box;
        .left{
          width: 50%;
          .left-item{
            width: 100%;
            height: 166px;
            // border-left:5px solid #0170fe ;
            // border-radius: 10px;
            padding: 10px 40px;
            // margin-bottom: 20px;
            // line-height: 100px;
            font-size: 16px;
            // color: #DCE5FE;
            box-sizing: border-box;
            display: flex;
            align-items: center;
            // box-shadow: 5px 5px 5px #DCE5FE;
            background: url("../../../../static/images/operationFlow/hxys.png") no-repeat;
            background-position: left;
            div{
              text-align: left;
            }
          }
        }
        .right{
          width: 700px;
          height: 700px;
          margin-top:-100px;
          /*background: url("../../../../static/images/operationFlow/qqgif.gif") no-repeat;*/
          .lz{
            border: 3px dashed #A7C5FC;
            border-radius: 50%;
            width: 440px;
            height: 440px;
            margin-top: 150px;
            margin-left: 130px;
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
            font-size: 32px;
            font-weight: bold;
            color: #023C97;
          }
        }
      }
    }
    .three-wrap {
      width: 100%;
      min-height: 50vh;
      background: #FFFFFF;
      /*height: 80vh;*/
      .move-content {
        height: auto;
        .el-tabs {
          width: 100%;

          /deep/.fnt-title{
            // color: red;
            text-align: center;
          }
          /deep/ .el-tabs__nav {
            width: 25%;
            // border-bottom: 2px solid #fff;
          }
          /deep/ .el-tabs__active-bar {
            width: 15% !important;
            left: 35%;
            background-color: #0170fe;
            height: 4px;
          }
          /deep/ .el-tabs__item {
            width: 100%;
            height: 80px;
            /*max-height: 128px;*/
          }
          /deep/.el-tabs__item.is-active {
            color: #0170fe;
          }
        }
      }
      .tab-slot {
        width: 100%;
        display: flex;
        height: 80px;
        position: relative;
        justify-items: center;
        margin: auto;
        img{
          margin-left: 25%;
          width: 70px;
          height: 70px;
        }
        div {
          padding-left: 20px;
          height: 70px;
          line-height: 70px;
          text-align: left;
          width: calc(100% - 70px);
        }
      }
      .tab-info {
        position: relative;
        display: flex;
        justify-content: space-between;
        // background-color: pink;
        background: url("../../../../static/images/operationFlow/sycj.png") no-repeat;
        height: 500px;
        width: 100%;
        padding: 50px 70px;
        box-sizing: border-box;
        .item{
          background-color:#fff;
          border-radius: 10px;
          width: 100%;
          height: 100%;
          box-sizing: border-box;
          padding: 70px 50px;
          display: flex;
          .item-left{
            width: 180px;
            height: 90px;
            border-radius: 10px;
            font-size: 24px;
            line-height: 90px;
            text-align: center;
            background-color: #0170FE;
            color: #fff;
          }
          .item-right{
            flex: 1;
            margin-left: 100px;
            display: flex;
            flex-direction: column;
            justify-content: space-between;
            text-align: left;
            .right-item{
              .title{
                font-size: 24px;
                background: url("../../../../static/images/operationFlow/sycjwz.png") no-repeat;
                background-position: bottom left;
                width: 350px;
                height: 34px;
              }
              .text{
                font-size: 16px;
                // color: #DCE5FE;
                margin-top: 15px;
              }
            }

          }
        }
      }
    }
    .fourth-wrap {
      width: 100%;
      // min-height: 70vh;
      background: #fff;
      .move-content {
        width: 100%;
        padding: 0 100px;
        box-sizing: border-box;
        display: flex;
        justify-content: space-between;
        height: 60vh;

        .main{
          width: 50%;
          /*height: 530px;*/
          text-align: left;
          padding: 50px;
          box-sizing: border-box;
          border-radius: 10px;
          display: flex;
          flex-direction: column;
          justify-content: space-between;
          /*background: url("../../../../static/images/operationFlow/khalfd.png") no-repeat;*/
          background-size: 100% 100%;
          .title{
            color: #fff;
            font-size: 24px;
            font-weight: bold;
          }
          .text{
            font-size: 16px;
            color: #DCE5FE;
            line-height: 32px;
          }
          ul{
            margin: 0;
            padding: 0;
            list-style-type: none;
            font-size: 16px;
            color: #DCE5FE;
            li{
              margin-top: 20px;
              span{
                margin-left:10px;
              }
            }
          }
        }
        .item{
          width: 25%;
          /*height: 530px;*/
          display: flex;
          flex-direction: column;
          border-radius: 10px ;
          text-align: left;
          padding: 50px;
          box-sizing: border-box;
          justify-content: space-between;
          /*background: url("../../../../static/images/operationFlow/khal.png") no-repeat;*/
          background-size: 100% 100%;
          .top{
            .title{
              font-size: 24px;
              font-weight: bold;
            }
            .text{
              margin-top:20px;
              font-size: 16px;
              // color: #DCE5FE;
              line-height: 32px;
            }
          }
          .bottom{
            .attribute{
              font-size: 20px;
            }
            .val{
              margin-top: 20px;
              font-size: 20px;
              width: 216px;
              height: 41px;
              padding-left: 10px;
              line-height: 41px;
              color: #046FFE;
              background: url("../../../../static/images/operationFlow/khalbq.png") no-repeat;
            }
          }

        }
      }
    }
  }
  @media screen and (min-width: 1501px){
    .move-title {
      margin-top: 30px;
      position: relative;
      top: 50px;
      width: 100%;
      z-index: 999;
      font-size: 32px;
      color: #323232;
      font-weight: 500;
    }
    .move-content {
      margin-top: 150px;
      position: relative;
      width: 100%;
      height: 50vh;
      z-index: 999;
      display: flex;
      justify-content: space-between;
    }
    .wrap{
      width: 100%;
      height: 100%;
      /*overflow: auto;*/
    }
    .div-bg {
      width: 100%;
      height:70vh;
      /*background: url("../../../../static/images/productAndService/bigData/bg.png") no-repeat;*/
      background-size: 100% 100%;
      img {
        width: 100%;
        height: 100%;
        background-size: 100% 100%;
      }
      .big-data_p {
        position: relative;
        left: 100px;
        top: -60%;
        color: #fff;
        text-align: left;
        width: calc(100% - 100px);
        z-index: 999;
      }
      .big-data_p .title, .big-data_p p {
        display: -webkit-box;
        overflow: hidden;
        -webkit-line-clamp: 2;
        -webkit-box-orient: vertical;
      }
      .big-data_p p {
        font-size: 24px;
      }
      .big-data_p .title {
        width: 100%;
        font-size: 42px;
        font-weight: 400;
        margin-bottom: 15px;
        line-height: 60px;
        max-height: 120px;
      }
      .big-data_p .el-button {
        margin-top: 10vh;
        width: 150px;
        color: #FFFFFF;
        background-color: transparent;
        border: 1px solid #FFFFFF;
        font-size: 16px;
      }
    }
    .tab-wrap {
      position: relative;
      top: -35px;
      width: 90%;
      height: 70px;
      margin-left: 5%;
      background-color: #FFFFFF;
      box-shadow: 0 0 8px 8px rgba(0, 18, 31, 0.07);
      .el-radio-group{
        width: 100%;
        height: 70px;
        .el-radio-button{
          width: 25%;
          height: 70px;
          /deep/ .el-radio-button__inner {
            width: 100%;
            height: 70px;
            line-height: 50px;
            font-size: 20px;
            box-shadow: -1px 0 0 0 transparent;
            background-color: transparent;
            color: #323232;
            border: 1px solid transparent;
          }
        }
      }
      /deep/ .line {
        width: 2px;
        height: 50px;
        border-left: 2px solid #f1f1f1;
        float: right;
      }
    }
    .first-wrap{
      width: 100%;
      // margin-left: 5%;
      background: #FFFFFF;
      // height: 60vh;
      .move-content{
        // background-color: cyan;
        width:100%;
        height: 585px;
        padding: 100px;
        box-sizing: border-box;
        display: flex;
        /*background: url("../../../../static/images/operationFlow/cpgn.png") no-repeat;*/
        .left{
          width: 440px;
          display: flex;
          flex-direction: column;
          justify-content: center;
          align-items: center;
          padding:0 100px;
          box-sizing: border-box;
          .left-title{
            font-size: 30px;
            color: #fff;
            font-weight: bold;
            margin-bottom: 20px;
          }
          .left-text{
            font-size: 16px;
            color: #DCE5FE;
            text-align: left;
          }
        }
        .right{
          flex: 1;
          padding:0 100px 0 0;
          box-sizing: border-box;
          .container{
            display: flex;
            flex-direction: column;
            justify-content: space-between;
            border-radius: 10px;
            background-color: rgba(255, 255, 255, 0.8);
            width: 100%;
            height: 100%;
            text-align: left;
            padding: 50px;
            box-sizing: border-box;
            .right-top{
              .top-title{
                font-size: 30px;
                font-weight: bold;
              }
              .top-text{
                margin-top: 20px;
                font-size: 16px;
                // color: #DCE5FE;
              }
            }
            .right-bottom{
              .bottom-title{
                font-size: 30px;
                font-weight: bold;
              }
              .bottom-text{
                margin-top: 20px;
                font-size: 16px;
                // color: #DCE5FE;
              }
            }
            .line{
              height: 1px;
              width: 100%;
              background-color: #F0F1F1;
            }
          }

        }
      }
    }
    .second-wrap {
      width: 100%;
      // height: 950px;
      // background: url("../../../../static/images/productAndService/bigData/core-bg.png") no-repeat;
      // background-size: 100% 100%;
      padding-bottom: 50px;
      .move-content {
        display: flex;
        padding:0 150px;
        box-sizing: border-box;
        .left{
          .left-item{
            width: 936px;
            height: 166px;
            // border-left:5px solid #0170fe ;
            // border-radius: 10px;
            padding: 10px 40px;
            // margin-bottom: 20px;
            // line-height: 100px;
            font-size: 16px;
            // color: #DCE5FE;
            box-sizing: border-box;
            display: flex;
            align-items: center;
            // box-shadow: 5px 5px 5px #DCE5FE;
            background: url("../../../../static/images/operationFlow/hxys.png") no-repeat;
            background-position: left;
            div{
              text-align: left;
            }
          }
        }
        .right{
          width: 700px;
          height: 700px;
          margin-top:-100px;
          /*background: url("../../../../static/images/operationFlow/qqgif.gif") no-repeat;*/
          .lz{
            border: 3px dashed #A7C5FC;
            border-radius: 50%;
            width: 440px;
            height: 440px;
            margin-top: 150px;
            margin-left: 130px;
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
            font-size: 32px;
            font-weight: bold;
            color: #023C97;
          }
        }
      }
    }
    .three-wrap {
      width: 100%;
      min-height: 50vh;
      background: #FFFFFF;
      /*height: 80vh;*/
      .move-content {
        height: auto;
        .el-tabs {
          width: 100%;

          /deep/.fnt-title{
            // color: red;
            text-align: center;
          }
          /deep/ .el-tabs__nav {
            width: 25%;
            // border-bottom: 2px solid #fff;
          }
          /deep/ .el-tabs__active-bar {
            width: 15% !important;
            left: 35%;
            background-color: #0170fe;
            height: 4px;
          }
          /deep/ .el-tabs__item {
            width: 100%;
            height: 80px;
            /*max-height: 128px;*/
          }
          /deep/.el-tabs__item.is-active {
            color: #0170fe;
          }
        }
      }
      .tab-slot {
        width: 100%;
        display: flex;
        height: 80px;
        position: relative;
        justify-items: center;
        margin: auto;
        img{
          margin-left: 25%;
          width: 70px;
          height: 70px;
        }
        div {
          padding-left: 20px;
          height: 70px;
          line-height: 70px;
          text-align: left;
          width: calc(100% - 70px);
        }
      }
      .tab-info {
        position: relative;
        display: flex;
        justify-content: space-between;
        // background-color: pink;
        background: url("../../../../static/images/operationFlow/sycj.png") no-repeat;
        height: 500px;
        width: 100%;
        padding: 50px 70px;
        box-sizing: border-box;
        .item{
          background-color:#fff;
          border-radius: 10px;
          width: 100%;
          height: 100%;
          box-sizing: border-box;
          padding: 70px 50px;
          display: flex;
          .item-left{
            width: 180px;
            height: 90px;
            border-radius: 10px;
            font-size: 24px;
            line-height: 90px;
            text-align: center;
            background-color: #0170FE;
            color: #fff;
          }
          .item-right{
            flex: 1;
            margin-left: 100px;
            display: flex;
            flex-direction: column;
            justify-content: space-between;
            text-align: left;
            .right-item{
              .title{
                font-size: 24px;
                background: url("../../../../static/images/operationFlow/sycjwz.png") no-repeat;
                background-position: bottom left;
                width: 350px;
                height: 34px;
              }
              .text{
                font-size: 16px;
                // color: #DCE5FE;
                margin-top: 15px;
              }
            }

          }
        }
      }
    }
    .fourth-wrap {
      width: 100%;
      // min-height: 70vh;
      background: #fff;
      .move-content {
        width: 100%;
        padding: 0 100px;
        box-sizing: border-box;
        display: flex;
        justify-content: space-between;
        height: 60vh;

        .main{
          width: 50%;
          /*height: 530px;*/
          text-align: left;
          padding: 100px;
          box-sizing: border-box;
          border-radius: 10px;
          display: flex;
          flex-direction: column;
          justify-content: space-between;
          /*background: url("../../../../static/images/operationFlow/khalfd.png") no-repeat;*/
          background-size: 100% 100%;
          .title{
            color: #fff;
            font-size: 24px;
            font-weight: bold;
          }
          .text{
            font-size: 16px;
            color: #DCE5FE;
            line-height: 32px;
          }
          ul{
            margin: 0;
            padding: 0;
            list-style-type: none;
            font-size: 16px;
            color: #DCE5FE;
            li{
              margin-top: 20px;
              span{
                margin-left:10px;
              }
            }
          }
        }
        .item{
          width: 25%;
          /*height: 530px;*/
          display: flex;
          flex-direction: column;
          border-radius: 10px ;
          text-align: left;
          padding: 100px;
          box-sizing: border-box;
          justify-content: space-between;
          /*background: url("../../../../static/images/operationFlow/khal.png") no-repeat;*/
          background-size: 100% 100%;
          .top{
            .title{
              font-size: 24px;
              font-weight: bold;
            }
            .text{
              margin-top:20px;
              font-size: 16px;
              // color: #DCE5FE;
              line-height: 32px;
            }
          }
          .bottom{
            .attribute{
              font-size: 20px;
            }
            .val{
              margin-top: 20px;
              font-size: 20px;
              width: 216px;
              height: 41px;
              padding-left: 10px;
              line-height: 41px;
              color: #046FFE;
              background: url("../../../../static/images/operationFlow/khalbq.png") no-repeat;
            }
          }

        }
      }
    }
  }
  .footer-style {
    width: 100%;
    height: 500px;
  }
</style>



// WEBPACK FOOTER //
// src/pages/home/productAndService/bigData/operationFlow.vue